module.exports = __webpack_public_path__ + "static/media/valor2.14839d5d.png";